import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { SceneSpotify as SceneSpotifyType } from "@ltypes/scene";
import DisplayForm from "@components/forms/DisplayForm/DisplayForm";
import TextField from "@components/forms/TextField/TextField";
import Message from "@components/ui/Message/Message";
import User, { UserApiCredential } from "@ltypes/user";
import Product from "@ltypes/product";
import { displayModes } from "../../../constants";

type SceneSpotifyProps = {
    scene: SceneSpotifyType,
    onChange: (field: string, value: string|number) => void,
};

function SceneSpotify(props: SceneSpotifyProps) {

    const { t } = useTranslation();
    const user: User = useSelector((state: any) => state.user);
    const product: Product = useSelector((state: any) => state.product);

    const credentials: UserApiCredential|null = user?.api_credentials.find((value: UserApiCredential) => value.type === 'SPOTIFY') ?? null;

    return (
        <div className="row g-3">
            <div className="col-12 col-md-6">
                <div className="row g-3">
                    <div className="col-12">
                        <DisplayForm label={t('page.scenes.data.display_mode')} value={props.scene.display_mode} items={displayModes[product.model.type].spotify.map((index: number) => ({
                            id: index,
                            background: `spotify-${index}`,
                        }))} productModelType={product.model.type} onChange={(value: number) => props.onChange('display_mode', value)}/>
                    </div>
                    <div className="col-12">
                        <TextField label={t('page.scenes.data.display_duration')} value={props.scene.display_duration} onChange={(value: string) => props.onChange('display_duration', value)}/>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="row g-3">
                    <div className="col-12">
                        {(credentials === null || !credentials.authorized) ? (
                            <Message type="warning">
                                <Trans i18nKey="message.spotify_link_account" components={{ break: <br />, lnk: <Link to="/account"/> }} />
                            </Message>
                        ) : (
                            <Message type="success">
                                <Trans i18nKey="message.spotify_linked_account" components={{ break: <br />, lnk: <Link to="/account"/> }} />
                            </Message>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SceneSpotify;
